import {
    inject,
    Injectable,
    NgZone,
    OnDestroy,
} from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { OfflineToastComponent } from 'app/common/offline-toast/offline-toast.component';

@Injectable({ providedIn: 'root' })
export class OfflineService implements OnDestroy {
    private hasInitialized = false;
    private wasOffline = !navigator.onLine;
    private activeDialogRef: MatDialogRef<OfflineToastComponent> | null = null;
    private _matDialog: MatDialog = (inject(MatDialog));


    constructor(
        private readonly zone: NgZone,
    ) {
        this.monitorNetwork();
    }
    private onlineListener = () => this.zone.run(() => this.updateStatus(true));
    private offlineListener = () => this.zone.run(() => this.updateStatus(false));

    private monitorNetwork(): void {
        if (!navigator.onLine) {
            this.showToast('youAreOffline', 'offline', true);
        }

        window.addEventListener('online', this.onlineListener);
        window.addEventListener('offline', this.offlineListener);
    }

    private removeNetworkListeners(): void {
        window.removeEventListener('online', this.onlineListener);
        window.removeEventListener('offline', this.offlineListener);
    }

    private updateStatus(online: boolean): void {
        if (!this.hasInitialized && online) {
            this.hasInitialized = true;
            return;
        }
        this.hasInitialized = true;

        if (online && this.wasOffline) {
            this.showToast('backOnline', 'online', false);
            this.wasOffline = false;
        } else if (!online) {
            this.showToast('youAreOffline', 'offline', true);
            this.wasOffline = true;
        }
    }

    private showToast(message: string, status: 'online' | 'offline', persist: boolean): void {
        this.clearToast();

        const isOffline = status === 'offline';
        this.activeDialogRef = this._matDialog.open(OfflineToastComponent, {
            data: {
                isOffline: isOffline
            },
            disableClose: true
        });

        if (!persist) {
            setTimeout(() => this.clearToast(), 4000);
        }
    }

    private clearToast(): void {
        if (this.activeDialogRef) {
            this.activeDialogRef.close();
            this.activeDialogRef = null;
        }
    }

    ngOnDestroy(): void {
        this.removeNetworkListeners();
        this.clearToast();
    }
}
